import getConfig from '../../../config';

export const routeSchemaMap = {
	learnAppRoute: '/learn/app',
	appseriesRoute: '/learn/app/level',
	tutorialSeriesRoute: '/learn/app/level/field/playlist',
	tutorialpageRoute: '/learn/app/level/field/playlist/tutorial',
	foryouRoute: '/learn/you',
	completedTutorialsRoute: '/learn/completed',
};

export const discoverRouteSchemaMap = {
	learnAppRoute: '/cc/discover/learn',
	appseriesRoute: '/cc/discover/learn/app/level',
	tutorialSeriesRoute: '/cc/discover/learn/app/level/field/playlist',
	tutorialpageRoute: '/cc/discover/learn/app/level/field/playlist/tutorial',
	foryouRoute: '/cc/discover/learn',
	completedTutorialsRoute: '/cc/discover/learn',
};

export const clientID = getConfig('CLIENT_ID');

export const languageUnavailableID = 'app.learn.language.unavailable.message';
export const languageLabelID = 'app.learn.language.label';
export const languageContinueID = 'app.learn.language.continue.label';
export const languagePlaceholderID = 'app.learn.language.select.placeholder';
export const emptyStateImage = 'https://public.adobecc.com/files/1UYFQOJDJL4022DWSN1ZDOFCKLVFFF';

export const learnSupportedLangs = ['de', 'en', 'fr', 'ko', 'ja']; // english, french, japanese, korean, german
